import { withFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import "../../styles/vendor/react-checkbox-tree.css";
import BasicInput from "./fields/BasicInput";
import BasicRadioList from "./fields/BasicRadioList";
import BasicSelect from "./fields/BasicSelect";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    user: PropTypes.object
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <form
        className="m-form m-form--fit m-form--label-align-right"
        onSubmit={handleSubmit}
      >
        <div className="form-group m-form__group row">
          <div className="col-10 ml-auto">
            <h3 className="m-form__section">Personal Details</h3>
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            First Name
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="text"
              name="firstname"
              noFormGroup
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Last Name
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="text"
              name="lastname"
              noFormGroup
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Gender
          </label>
          <div className="col-7">
            <BasicRadioList
              {...this.props}
              name="gender"
              noFormGroup
              options={[
                { value: "female", label: "Female" },
                { value: "male", label: "Male" },
                { value: "other", label: "Other" }
              ]}
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Size
          </label>
          <div className="col-7">
            <BasicSelect
              {...this.props}
              name="size"
              noFormGroup
              options={[
                { value: "XS", title: "Extra Small" },
                { value: "S", title: "Small" },
                { value: "M", title: "Medium" },
                { value: "L", title: "Large" },
                { value: "XL", title: "XL" },
                { value: "XXL", title: "XXL" }
              ]}
            />
            <span className="m-form__help">
              This is used to supply you with the correct T-shirt size if
              needed.
            </span>
          </div>
        </div>
        <div className="form-group m-form__group row">
          <label htmlFor="example-text-input" className="col-2 col-form-label">
            Phone No.
          </label>
          <div className="col-7">
            <BasicInput
              {...this.props}
              type="text"
              name="telephone"
              noFormGroup
            />
          </div>
        </div>
        <div className="m-form__actions">
          <div className="row">
            <div className="col-2" />
            <div className="col-7">
              <button
                type="submit"
                className="btn btn-brand m-btn m-btn--custom"
              >
                Save changes
              </button>
              &nbsp;&nbsp;
              <button
                type="reset"
                className="btn btn-secondary m-btn m-btn--custom"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const EditProfileForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      firstname: props.user.firstName,
      lastname: props.user.lastName,
      telephone: props.user.telephone,
      gender: props.user.gender,
      size: props.user.size
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.firstname || values.firstname === "") {
      errors.firstname = "required";
    }

    if (!values.lastname || values.lastname === "") {
      errors.lastname = "required";
    }

    if (props.user.permissions.length === 0 && (!values.telephone || values.telephone === "")) {
      errors.telephone = "required";
    }

    if (!values.gender || values.gender === "") {
      errors.gender = "required";
    }

    if (!values.size || values.size === "") {
      errors.size = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default EditProfileForm;
